import { Route } from 'react-router-dom';

import PublicWorkspaceLayout from '@/features/Workspace/PublicWorkspaceLayout';

import PublicReportPage from '../features/Report/pages/PublicReportPage';
import { SharedLinkPage } from '../features/SharedLink';
import PublicStudioItemDetailPage from '../features/Studio/pages/public-studio-item-detail-page';
import ShareLayout from '../layouts/ShareLayout';
import SuspenseLayout from '../layouts/SuspenseLayout';

const shareRoutes = (
  <Route element={<SuspenseLayout />}>
    <Route path="share" element={<ShareLayout />}>
      <Route path="workspace/:workspace_id" element={<PublicWorkspaceLayout />}>
        <Route path="report/:report_alias" element={<PublicReportPage />} />
        <Route
          path="studio/:studio_item_alias"
          element={<PublicStudioItemDetailPage />}
        />
      </Route>
    </Route>
    <Route path="shared-link/:linkId" element={<SharedLinkPage />} />
  </Route>
);

export default shareRoutes;
